<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <edit-user-form :id="parseInt(this.$route.params.id)">

      </edit-user-form>
    </div>
  </div>
</template>
<script>
  import EditUserForm from './BGBackendEditUserForm.vue'

  export default {
    components: {
      EditUserForm
    },
    created () {
      this.$log.debug('User.created ' + this.$route.params.id)
    },
    beforeCreate () {
      this.$log.debug('User.beforeCreate ' + this.$route.params.id)
    },
    mounted () {
      this.$log.debug('User.mounted ' + this.$route.params.id)
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/User.vue